import gsap from 'gsap'

const closeLogin = () => {
    const targets = Array.from(document.querySelectorAll('.offscreen-translator'))
    targets.forEach(target => target.classList.remove('active'))
    gsap.to(targets, {x:'0'})
}

export default closeLogin